import { render, staticRenderFns } from "./addAppVersion.vue?vue&type=template&id=79901315&scoped=true"
import script from "./addAppVersion.vue?vue&type=script&lang=js"
export * from "./addAppVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79901315",
  null
  
)

export default component.exports